
import { defaultHttpResponse, HttpResponse } from '../auth/AuthInterface';

import { ParteProps } from '../recepcion/ParteInterface';

import { NotificacionesProps } from '../notificaciones/NotificacionesInterface';
import { defaultExpediente, ExpedienteProps } from '../recepcion/ExpedienteInterface';

// Definición de defaults

export const defaultSentencia: SentenciaProps = {
    idSentencia: 0,
    numeroSentencia: '',
    juez: '',
    contenido: '',
    documento: '',
    idEstatus: 0,
    idPlantilla: 0,
    plantilla: '',
    tipoSentencia: '',
    sentidoSentencia: '',
    idSentidoSentencia: 0,
    perspectivaGenero: false,
    asignadoMismoUsuario: false,
    usuarioAsignado: '',
    idExpediente: 0,
    expediente: defaultExpediente,
    idTipoSentencia: 0,
    resuelveRecurso: false,
    idMedioImpugnacion: 0,
    idSentidoFallo: 0,
    medioImpugnacion: false,
    resuelveIncidente: false,
    idIncidente: 0,
    incidente: false,
    observaciones: false,
    usuarioObservaciones: [],
    partes: [],
    notificaciones: [],
}

export const defaultBuscarSentencia: BuscarSentenciasProps = {
    idSentencia: 0,
    numeroSeguimiento: '',
    numeroSentencia: '',
    tipoSentencia: '',
}

export const defaultNuevaSentencia: NuevaSentenciaResponse = {
    ...defaultHttpResponse,
    idSentencia:    '',
}

export const defaultActualizarEstatus: ActualizarEstatusResponse = {
    ...defaultHttpResponse,
    asignadoMismoUsuario:   false,
    usuarioAsignado:        '',
}

// Creación de interfaces

export interface NuevaSentenciaParams {
    idExpediente: number;
    idTipoSentencia: number;
    idCitacionSentencia: number;
}

export interface NuevaSentenciaResponse extends HttpResponse {
    idSentencia: string;
}

export interface SentenciaProps {
    idSentencia:            number;
    numeroSentencia:        string;
    juez:                   string;
    contenido:              string;
    documento:              string;
    idEstatus:              number;
    idPlantilla:            number;
    plantilla:              string;
    tipoSentencia:          string;
    sentidoSentencia:       string;
    idSentidoSentencia:     number;
    perspectivaGenero:      boolean;
    asignadoMismoUsuario:   boolean;
    usuarioAsignado:        string;
    idExpediente:           number;
    expediente:             ExpedienteProps;
    idTipoSentencia:        number;
    resuelveRecurso:        boolean;
    idMedioImpugnacion:     number;
    idSentidoFallo:         number;
    medioImpugnacion:       boolean;
    resuelveIncidente:      boolean;
    idIncidente:            number;
    incidente:              boolean;
    observaciones:          boolean;
    usuarioObservaciones:   UsuarioObservacionesProps[];
    partes:                 ParteProps[];
    notificaciones:         NotificacionesProps[];
    fecha?:                 Date;
    fechaCitacion?:         Date;
}

export interface DetalleSentenciaResponse extends HttpResponse, SentenciaProps { }

export interface ActualizarSentenciaParams {
    idSentencia:            string;
    contenido:              string;
    idPlantilla:            number;
    idSentidoSentencia:     number;
    perspectivaGenero:      boolean;    
    resuelveRecurso:        boolean;
    idMedioImpugnacion:     number;
    idSentidoFallo:         number;   
    resuelveIncidente:      boolean;
    idIncidente:            number;
}

export interface ActualizarEstatusParams {
    idSentencia:            string;
    idEstatus:              number;
    observaciones:          string;
}

export interface ActualizarEstatusResponse extends HttpResponse{
    asignadoMismoUsuario:   boolean;
    usuarioAsignado:        string;
}

export interface UsuarioObservacionesProps {
    usuario:        string;
    puesto:         string;
    observacion:    string;
    fecha?:         Date;
}

export interface GuardarNotificacionesParams {
    idSentencia:        number;
    notificaciones:     NotificacionesProps[];
}

export interface BuscarSentenciasProps {
    idSentencia:        number;
    numeroSentencia:    string;
    numeroSeguimiento:  string;
    tipoSentencia:      string;
    fecha?:             Date;
}